import { USERS_ACTIONS } from "./Users.actions";
import { DEFAULT_CUSTOMER_USERS_LIST_FILTERS } from "./Users.constants";

export const UsersReducer = (state, action) => {
  switch (action.type) {
    case USERS_ACTIONS.LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case USERS_ACTIONS.ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case USERS_ACTIONS.LIST_FILTERS:
      return {
        ...state,
        listFilters: action.payload ?? DEFAULT_CUSTOMER_USERS_LIST_FILTERS,
      };
    case USERS_ACTIONS.USERS: {
      const list = action.payload?.list ?? action.payload;
      const pagination = action.payload?.pagination ?? state.pagination;
      const listFilters =
        action.payload?.listFilters !== undefined
          ? action.payload.listFilters
          : state.listFilters;
      return {
        ...state,
        usersList: Array.isArray(list) ? list : [],
        pagination: pagination ?? state.pagination,
        listFilters,
        error: null,
      };
    }
    default:
      return state;
  }
};
